import {Sort} from '@pluto/table';
import {SetUsersAction} from '@pluto/users';
import {DateRangeState} from '@pluto/daterange-picker';
import {ContentPartners} from '@pluto/content-partners/ContentPartnersTypes';
import {ContentTypes} from '@pluto/content-types';
import {UsersState} from '@pluto/users/UsersTypes';
import {QCJobsStatusesState} from '@pluto/qc-jobs-statuses/QCJobsStatusesTypes';

export enum QCType {
    Ingress = 'Ingress',
    Egress = 'Egress',
}

export enum QCFormattedStatusEnum {
    InQc = 'In QC',
    ReadyForQc = 'Ready for QC',
    QcFailed = 'QC Failed',
    QcPassed = 'QC Passed',
}

export enum QCStatusEnum {
    InQc = 'IN_QC',
    ReadyForQc = 'READY_FOR_QC',
    QcFailed = 'QC_FAILED',
    QcPassed = 'QC_PASSED',
}

export enum QCJobsStatusEnum {
    InQc = 'IN_QC',
    ReadyForQc = 'READY_FOR_QC',
    QcPassed = 'QC_PASSED',
}

export enum DateSort {
    dueDate = 'dueDate',
    finishDate = 'finishDate',
}

export type QCStatus = string[];

export interface BaseFilters {
    limit: number;
    offset: number;
}

export type QCSpecificFiltersType =
    | 'qcJobType'
    | 'contentPartnerId'
    | 'qcJobAssigneeId'
    | 'qcJobStatus';

export interface QCSpecificFilters {
    qcJobType?: QCType | string;
    contentPartnerId: string[];
    contentItemType: string[];
    qcJobAssigneeId?: string[];
    qcJobStatus: string[];
}

export interface QCFilters extends BaseFilters, QCSpecificFilters, Sort {
    title: string;
    dates?: DateRangeState;
    dateStart?: string;
    dateEnd?: string;
    finishDates?: DateRangeState;
    finishDateEnd?: string;
    finishDateStart?: string;
}

export interface QCFiltersStore {
    contentPartners: ContentPartners;
    contentTypes: ContentTypes;
    users: UsersState;
    qcJobsStatuses: QCJobsStatusesState;
}

export interface QCFiltersConnected extends QCFiltersStore {
    setContentPartners: () => void;
    setUsers: SetUsersAction;
    setQCStatuses: () => void;
}
